import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Form as FinalForm } from 'react-final-form';
import { Form, SecondaryButton } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';
import css from './BusinessAdminSettingForm.module.css';
import { apiBaseUrl } from '../../util/api';
import { IoIosSave } from "react-icons/io";

const BusinessAdminSettingForm = props => {
  const { currentBusiness } = props;
  const [savedCommission, setSavedCommission] = useState(0);
  const [commissionRate, setCommissionRate] = useState(0);

  useEffect(() => {
    const rate = currentBusiness?.data?.attributes?.profile?.privateData?.commissionRate;
    if (rate !== undefined) {
      setCommissionRate(rate);
      setSavedCommission(rate);
    }
  }, [currentBusiness]);

  const handleApiSubmit = async () => {
    const businessId = currentBusiness?.data?.id?.uuid;
    if (!businessId) {
      console.error('Missing business ID. Cannot update commission rate.');
      return;
    }

    try {
      await axios.post(
        `${apiBaseUrl()}/api/user/admin/updateCommissionRate`,
        {
          id: businessId,
          commissionRate: Number(commissionRate),
        },
        {
          withCredentials: true,
        }
      );
      setSavedCommission(commissionRate);
    } catch (error) {
      console.error('Failed to update commission rate:', error);
    }
  };

  const isUnchanged = Number(commissionRate) === Number(savedCommission);

  return (
    <FinalForm
      onSubmit={async values => {
        await handleApiSubmit();
        onSubmit({ ...values, commissionRate });
      }}
      render={({ handleSubmit, submitting }) => (
        <Form onSubmit={handleSubmit}>
          <div className={css.fieldGroup}>
            <label htmlFor="commissionRate">
              <FormattedMessage id="CommissionRateForm.label" defaultMessage="Commission (%)" />
            </label>
            <div className={css.commissionRow}>
              <input
                id="commissionRate"
                name="commissionRate"
                type="number"
                step="1"
                value={commissionRate}
                onChange={e => setCommissionRate(e.target.value)}
                className={css.field}
                required
              />
              <SecondaryButton
                className={css.submitButton}
                type="submit"
                disabled={isUnchanged}
                inProgress={submitting}
              >
                <FormattedMessage id="CommissionRateForm.submit" defaultMessage="Save" /><IoIosSave />
              </SecondaryButton>
            </div>
          </div>
        </Form>
      )}
    />
  );
};

BusinessAdminSettingForm.propTypes = {
  currentBusiness: PropTypes.object,
};

export default BusinessAdminSettingForm;
